import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "w-full space-y-2 divide-y-2 divide-grey px-4" }
const _hoisted_3 = { class: "text-xl font-bold text-primary" }
const _hoisted_4 = { class: "flex items-center justify-between pt-1" }
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_away = _resolveDirective("click-away")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", {
      class: _normalizeClass(`cursor-pointer fill-darkgrey hover:fill-primary ${
        _ctx.isDropdownOpened && 'fill-primary'
      }`),
      height: "24px",
      viewBox: "0 0 24 24",
      width: "24px",
      xmlns: "http://www.w3.org/2000/svg",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)))
    }, [...(_cache[1] || (_cache[1] = [
      _createElementVNode("path", {
        d: "M0 0h24v24H0V0z",
        fill: "none"
      }, null, -1),
      _createElementVNode("path", { d: "M12.87 15.07l-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z" }, null, -1)
    ]))], 2)),
    _createElementVNode("div", {
      class: _normalizeClass(`absolute right-0 top-8 z-40 h-auto w-[250px] origin-top transform space-y-2 rounded-lg border-2 border-grey bg-white py-2 px-1 text-sm  shadow-lg duration-300 ease-in-out ${
        _ctx.isDropdownOpened ? 'scale-y-100' : 'scale-y-0'
      }`)
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t(_ctx.getSelectedLanguageName())), 1),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (language) => {
            return (_openBlock(), _createElementBlock("p", {
              class: _normalizeClass(`cursor-pointer text-darkgrey hover:text-primary ${
              language.code === _ctx.translation.currentLocale && 'text-primary'
            }`),
              onClick: () => _ctx.changeLanguage(language.code)
            }, _toDisplayString(_ctx.$t(language.name)), 11, _hoisted_5))
          }), 256))
        ])
      ])
    ], 2)
  ])), [
    [_directive_click_away, _ctx.isDropdownOpened && _ctx.toggleDropdown]
  ])
}